import { TranslationFile } from '../data/translation-file';

export abstract class TranslationLoader {
  abstract load(language: string, module?: string): Promise<TranslationFile>;
}
